import { render, staticRenderFns } from "./AccessRulesModalAdd.vue?vue&type=template&id=5005e823&"
import script from "./AccessRulesModalAdd.vue?vue&type=script&lang=js&"
export * from "./AccessRulesModalAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports